import { useState } from "react";
import {
  Box,
  Chip,
  Dialog,
  DialogTitle,
  IconButton,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import HistorySection from "./sections/HistorySection";
import { Company, OnboardingStateValues } from "models/Company";
import DataLabel from "components/DataLabel";
import Close from "@mui/icons-material/Close";
import ContactsSection from "./sections/ContactsSection";
import UeCodeChip from "../../components/UeCodeChip";
import OfficesSection from "./sections/OfficesSection";
import CompanyForm from "./components/CompanyForm";
import UsersSection from "./sections/UsersSection";

type ViewCompanyDialogProps = { company: Company; onClose: () => void };

function formatAddress(company: Company): string {
  const codeAndCity = [company.postalCode, company.city].filter(Boolean).join(" ");
  return [company.address, codeAndCity].filter(Boolean).join(", ");
}

const ViewCompanyDialog: React.FC<ViewCompanyDialogProps> = (props) => {
  const { company, onClose } = props;

  const [selectedTab, setSelectedTab] = useState<
    "contacts" | "history" | "info" | "offices" | "users"
  >("info");

  return (
    <Dialog
      open={true}
      fullWidth
      maxWidth="md"
      onClose={onClose}
      slotProps={{ container: { sx: { alignItems: "start" } } }}
    >
      <DialogTitle>
        {company.name}

        <Stack direction="row" alignItems="center" spacing={1}>
          {company.ueCode && <UeCodeChip ueCode={company.ueCode} />}

          <Typography variant="subtitle2" color="text.secondary">
            {formatAddress(company)}
          </Typography>
        </Stack>

        {company.state === "NEW" && (
          <DataLabel label="Status">
            <Chip label={OnboardingStateValues[company.onboardingState]} size="small" />
          </DataLabel>
        )}
      </DialogTitle>

      <IconButton
        onClick={onClose}
        sx={{ position: "absolute", right: 8, top: 12, color: "grey.500" }}
      >
        <Close />
      </IconButton>

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={selectedTab} onChange={(e, value) => setSelectedTab(value)}>
          <Tab value="info" label="Info" />
          <Tab value="users" label="Användare" />
          <Tab value="contacts" label="Kontakter" />
          <Tab value="offices" label="Kontor" />
          <Tab value="history" label="Historik" />
        </Tabs>
      </Box>

      {selectedTab === "info" && <CompanyForm companyToEdit={company} onClose={onClose} />}
      {selectedTab === "users" && <UsersSection company={company} />}
      {selectedTab === "contacts" && <ContactsSection company={company} />}
      {selectedTab === "offices" && <OfficesSection company={company} />}
      {selectedTab === "history" && <HistorySection company={company} />}
    </Dialog>
  );
};

export default ViewCompanyDialog;
